interface ErrorCodes {
  FILTER_TOWER_LEAK_DETECTED: boolean;
  FILTER_CLOGGED: boolean;
  WM_OUT_PRESSURE_LOW_TIMEOUT: boolean;
  FILLING_STORAGE_TANK_TIMEOUT: boolean;
  EMPTYING_STORAGE_TANK_TIMEOUT: boolean;
  EMPTYING_FILTER_TANK_TIMEOUT: boolean;
  PUMPING_FROM_WCU_TIMEOUT: boolean;
  CALIBRATION_FAILED: boolean;
  CALIBRATION_TIMEOUT: boolean;
  NO_COLD_WATER_FLOW_IN: boolean;
}

enum MB2Error {
  SLOW_LEAK = 0x20000,
  FILTER_CLOGGED = 0x2,
  WM_OUT_PRESSURE_LOW_TIMEOUT = 0x4,
  PUMPING_FROM_WCU_TIMEOUT = 0x40,
  WCU_PUMP_FAILURE = 0x800,
  FILTER_TOWER_LEAK_DETECTED = 0x1,
  EMPTYING_FILTER_TANK_TIMEOUT = 0x20,
  INACCURATE_PUMP_FLOW = 0x10000,
  CALIBRATION_TIMEOUT = 0x100,
  CALIBRATION_FAILED = 0x80,
  DISCARD_LOW_FLOW = 0x1000,
  DISCARD_HIGH_FLOW = 0x2000,
  STORE_HIGH_FLOW = 0x8000,
  STORE_LOW_FLOW = 0x4000,
  PUMPING_FROM_WCU_TIMEOUT_STARTUP = 0x40000,
  NO_FLOW_TO_WASHING_MACHINES = 0x80000,
  FILLING_STORAGE_TANK_TIMEOUT = 0x8,
  //WASHIN_MACHINE_INLET_CLOGGED = "Not Implemented",
  NO_COLD_WATER_FLOW_IN = 0x200,
  FILLING_FILTER_TANK_TIMEOUT = 0x100000,
  CALIBRATION_TEMPERATURE = 0x400000,
  CALIBRATION_CONDUCTIVITY = 0x200000,
  TURBIDITY_SENSOR = 0x2000000,
  TURBIDITY_SENSOR_DISCONNECTED = 0x4000000,
  CONDUCTIVITY_SENSOR = 0x800000,
  TEMPERATURE_SENSOR = 0x1000000,
  COND_SENSOR_DISCONNECTED = 0x8000000,
  WL_ST_SENSOR_DISCONNECTED = 0x10000000,
  WL_FT_SENSOR_DISCONNECTED = 0x20000000,
  WL_WCU_SENSOR_DISCONNECTED = 0x40000000,
  PRESSURE_SENSOR_DISCONNECTED = 0x80000000,
  HW_FLOW_SENSOR_DISCONNECTED = 0x100000000,
  CW_FLOW_SENSOR_DISCONNECTED = 0x200000000,
  PUMP_FLOW_SENSOR_DISCONNECTED = 0x400000000,
  WM2_FLOW_SENSOR_DISCONNECTED = 0x800000000,
  SERVING_INTO_FILTER_TANK = 0x1000000000,
  TOO_MUCH_WATER_SERVED = 0x2000000000,
}
const MB2_DISPLAY_ERRMASK: Record<number, number> = {
  [MB2Error.SLOW_LEAK]: 25,
  [MB2Error.FILTER_CLOGGED]: 26,
  [MB2Error.PUMPING_FROM_WCU_TIMEOUT]: 27,
  [MB2Error.WCU_PUMP_FAILURE]: 28,
  [MB2Error.FILTER_TOWER_LEAK_DETECTED]: 29,
  [MB2Error.EMPTYING_FILTER_TANK_TIMEOUT]: 30,
  [MB2Error.INACCURATE_PUMP_FLOW]: 31,
  [MB2Error.CALIBRATION_TIMEOUT]: 32,
  [MB2Error.CALIBRATION_FAILED]: 33,
  [MB2Error.DISCARD_LOW_FLOW]: 34,
  [MB2Error.DISCARD_HIGH_FLOW]: 35,
  [MB2Error.STORE_HIGH_FLOW]: 36,
  [MB2Error.STORE_LOW_FLOW]: 37,
  [MB2Error.PUMPING_FROM_WCU_TIMEOUT_STARTUP]: 38,
  [MB2Error.NO_FLOW_TO_WASHING_MACHINES]: 39,
  [MB2Error.FILLING_STORAGE_TANK_TIMEOUT]: 40,
  // [MB2Error.WASHIN_MACHINE_INLET_CLOGGED]: 41, Not implemented
  [MB2Error.NO_COLD_WATER_FLOW_IN]: 42,
  [MB2Error.FILLING_FILTER_TANK_TIMEOUT]: 43,
  [MB2Error.CALIBRATION_TEMPERATURE]: 44,
  [MB2Error.CALIBRATION_CONDUCTIVITY]: 45,
  [MB2Error.TURBIDITY_SENSOR]: 46,
  [MB2Error.TURBIDITY_SENSOR_DISCONNECTED]: 47,
  [MB2Error.CONDUCTIVITY_SENSOR]: 48,
  [MB2Error.TEMPERATURE_SENSOR]: 49,
  [MB2Error.COND_SENSOR_DISCONNECTED]: 50,
  [MB2Error.WL_ST_SENSOR_DISCONNECTED]: 51,
  [MB2Error.WL_FT_SENSOR_DISCONNECTED]: 52,
  [MB2Error.WL_WCU_SENSOR_DISCONNECTED]: 53,
  [MB2Error.PRESSURE_SENSOR_DISCONNECTED]: 54,
  [MB2Error.HW_FLOW_SENSOR_DISCONNECTED]: 55,
  [MB2Error.CW_FLOW_SENSOR_DISCONNECTED]: 56,
  [MB2Error.PUMP_FLOW_SENSOR_DISCONNECTED]: 57,
  [MB2Error.WM2_FLOW_SENSOR_DISCONNECTED]: 58,
  [MB2Error.WM_OUT_PRESSURE_LOW_TIMEOUT]: 59,
  [MB2Error.SERVING_INTO_FILTER_TANK]: 60,
  [MB2Error.TOO_MUCH_WATER_SERVED]: 61,
} as const;

export function decodeErrorCodesToObject(errorInt: number): string | null {
  const active = {
    FILTER_TOWER_LEAK_DETECTED: !!(errorInt & 0x1),
    FILTER_CLOGGED: !!(errorInt & 0x2),
    WM_OUT_PRESSURE_LOW_TIMEOUT: !!(errorInt & 0x4),
    FILLING_STORAGE_TANK_TIMEOUT: !!(errorInt & 0x8),
    EMPTYING_STORAGE_TANK_TIMEOUT: !!(errorInt & 0x10),
    EMPTYING_FILTER_TANK_TIMEOUT: !!(errorInt & 0x20),
    PUMPING_FROM_WCU_TIMEOUT: !!(errorInt & 0x40),
    CALIBRATION_FAILED: !!(errorInt & 0x80),
    CALIBRATION_TIMEOUT: !!(errorInt & 0x100),
    NO_COLD_WATER_FLOW_IN: !!(errorInt & 0x200),
  };
  return Object.keys(active)
    .filter((key) => active[key as keyof ErrorCodes])
    .join(", ");
}

export enum MB1Error {
  CLEARED = 0,
  TAP_PRESSURE_ERROR = 1,
  HUMIDITY_ERROR = 2,
  FIBER_CONTAINER_ERROR = 3,
  EMZ_3in1_SENSOR_ERROR = 4,
  RGP_TURB_SENSOR_ERROR = 5,
  RGB_TURB_SENSOR_DISCONNECTED_ERROR = 6,
  CALIBRATION_ERROR = 7,
  FILTER_BALL_VALVE_STUCK_CLOSED_ERROR = 8,
  STORAGE_BALL_VALVE_STICK_CLOSED_ERROR = 9,
  DRAIN_STORAGE_ERROR = 10,
  DRAIN_WCU_ERROR = 11,
  WATER_LEVEL_HIGH_WCU_ERROR = 12,
  MISSING_WATER_IN_WCU_ERROR = 13, // Not implemented
  FILTER_LEVEL_SENSOR_MALFUNCTION = 14,
  STORAGE_LEVEL_SENSOR_MALFUNCTION = 15,
  MAIN_FILTER_CLOGGED = 16,
  FIBER_BAG_EXPIRED = 17,
  PUMP_STUCK_ON = 18,
  FILLING_STORAGE_TANK_TIMEOUT = 19,
  WCU_DISCONNECTED = 20,
  SOME_SENSOR_DISCONNECTED = 21,
  PERMANENT_ERROR_STATE = 22,
}

export type MimboxErrorInfo = {
  label: string;
  description: string;
  indicatorClass?: string;
  bypassMode?: string; // MB1 specific
  errmaskDisplay?: number; // MB2 specific
};

const MB1_ERRORS: Record<MB1Error, MimboxErrorInfo> = {
  [MB1Error.CLEARED]: {
    label: "Codes cleared",
    description: "Last error was cleared",
  },
  [MB1Error.TAP_PRESSURE_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "Tap Pressure Error",
    description: "The tap pressure if below 0.5 bar",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.HUMIDITY_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "Humidity Error",
    description: "Humidity inside the Mimbox is higher than 90%",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.FIBER_CONTAINER_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "Fiber Container Error",
    description: "The fiber collector door is open for more than 5 min",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.EMZ_3in1_SENSOR_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "EMZ 3in1 sensor Error",
    description: "The 3in1 sensor is not responding (not possible to check water quality)",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.RGP_TURB_SENSOR_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "RGB-Turb sensor Error",
    description: "The RBG-Turb sensor is malfunctioning",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.RGB_TURB_SENSOR_DISCONNECTED_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "RGB-Turb sensor disconnected Error",
    description: "The RGB-Turb sensor is disconnected",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.CALIBRATION_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "Calibration Error",
    description: "The calibration sequence is not complected, after 3 attempts",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.FILTER_BALL_VALVE_STUCK_CLOSED_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "Filter ball valve stuck closed",
    description:
      "BV 6 closed (wrong position) flowrate <0.1/min, when the pumps are trying to drain the filter tank",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.STORAGE_BALL_VALVE_STICK_CLOSED_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "Storage ball valve stuck closed",
    description:
      "BV6 closed (wrong position) flowrate <0.1/min, when the pumps are trying to pump from the storage tank",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.DRAIN_STORAGE_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "Drain storage Error",
    description: "Can't drain the storage tank, level doesn't decrease when pumping",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.DRAIN_WCU_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "Drain WCU Error",
    description: "Can't drain the WCU, level doesn't decrease with valve open to sewer",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.WATER_LEVEL_HIGH_WCU_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "Water level high WCU Error",
    description: "The level in the WCU is stuck high for more than 60 min",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.MISSING_WATER_IN_WCU_ERROR]: {
    bypassMode: "Temporary bypass",
    label: "Missing water in WCU (NOT IMPLEMENTED)",
    description: "Washing Machines take water, but no water level in the WCU",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.FILTER_LEVEL_SENSOR_MALFUNCTION]: {
    bypassMode: "Temporary bypass",
    label: "Filter level sensor malfunction",
    description: "Water level in filter doesn't increase, after WCU pumps up water",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.STORAGE_LEVEL_SENSOR_MALFUNCTION]: {
    bypassMode: "Temporary bypass",
    label: "Storage level sensor malfunction",
    description: "Water level in storage tank doesn't increase, after pumping to storage",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.MAIN_FILTER_CLOGGED]: {
    bypassMode: "Temporary bypass",
    label: "Main filter clogged",
    description:
      "Filter is clogged, recovery sequence has failed to drain filter tank and do filter clean",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.FIBER_BAG_EXPIRED]: {
    bypassMode: "Normal",
    label: "Fiber bag expired",
    description: "Fiber bag has reached max number of filter cleans, not changed for 24h",
  },
  [MB1Error.PUMP_STUCK_ON]: {
    bypassMode: "Temporary bypass",
    label: "Pump stuck on",
    description: "The pumps are on for 10 min straight, stick draining filter (filter clogged)",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.FILLING_STORAGE_TANK_TIMEOUT]: {
    bypassMode: "Temporary bypass",
    label: "Filling storage tank timeout",
    description:
      "Filling the storage tank with tap water takes too long, 5 min timeout (manual valve is open or level sensor malfunction)",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.WCU_DISCONNECTED]: {
    bypassMode: "Temporary bypass",
    label: "WCU disconnected",
    description: "The WCU sensor is disconnected (could be all the low voltage WCU cable)",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.SOME_SENSOR_DISCONNECTED]: {
    bypassMode: "Temporary bypass",
    label: "Some sensor disconnected",
    description:
      "One of the following sensors is disconnected: lvl filter, lvl storage, high pressure, humidity",
    indicatorClass: "!bg-status-success-bypass",
  },
  [MB1Error.PERMANENT_ERROR_STATE]: {
    bypassMode: "Permanent bypass",
    label: "Permanent Error State",
    description:
      "The Mimbox has had the same error 3+ times in a week time period (check error history to which error caused this",
  },
};

function isKnownMB1Error(error: number): error is MB1Error {
  return error in MB1Error;
}

export function isErrorBitSet(errorNo: number, mask: number): boolean {
  return Math.floor(errorNo / mask) % 2 === 1;
}

export function getMB1ErrorInfo(errorNo: number, labelPrefix?: string): MimboxErrorInfo {
  if (!isKnownMB1Error(errorNo)) {
    return {
      label: `${labelPrefix}Unknown error`,
      description: "",
    };
  }

  if (labelPrefix && errorNo != MB1Error.CLEARED) {
    const error = MB1_ERRORS[errorNo];
    return {
      ...error,
      label: `${labelPrefix}${error.label}`,
    };
  }
  return MB1_ERRORS[errorNo];
}

function hideMB2Errors(errors: MimboxErrorInfo[]): MimboxErrorInfo[] {
  const ignoreList = [MB2_DISPLAY_ERRMASK[MB2Error.TURBIDITY_SENSOR]];
  return errors.filter(({ errmaskDisplay }) => {
    if (errmaskDisplay === undefined) {
      return true;
    }
    return !ignoreList.includes(errmaskDisplay);
  });
}
export function getMB2Errors(errorNo: number | null | undefined): MimboxErrorInfo[] {
  let errors: MimboxErrorInfo[] = [];

  if (!errorNo) {
    return errors;
  }
  let mb2err: keyof typeof MB2Error;
  for (mb2err in MB2Error) {
    const v = MB2Error[mb2err] as unknown as number;
    if (isErrorBitSet(errorNo, v)) {
      let label = mb2err.replace(/_/g, " ").toLowerCase();
      label = label.slice(0, 1).toUpperCase() + label.slice(1);
      const errmaskDisplay = MB2_DISPLAY_ERRMASK[v];
      let description = "";
      errors.push({ label: label, description: description, errmaskDisplay: errmaskDisplay });
    }
  }
  if (errors.length === 0) {
    errors.push({
      label: "Unknown Error",
      description: "",
    });
  }
  return hideMB2Errors(errors);
}

export function getMB2HighestPrioErrorInfo(errorNo: number | null | undefined): MimboxErrorInfo {
  let returnVal: MimboxErrorInfo = {
    label: "",
    description: "",
  };

  if (!errorNo) {
    return returnVal;
  }
  let mb2err: keyof typeof MB2Error;
  for (mb2err in MB2Error) {
    const v = MB2Error[mb2err] as unknown as number;
    if (isErrorBitSet(errorNo, v)) {
      let label = mb2err.replace(/_/g, " ").toLowerCase();
      label = label.slice(0, 1).toUpperCase() + label.slice(1);
      const errmaskDisplay = MB2_DISPLAY_ERRMASK[v];
      returnVal.label = label;
      returnVal.errmaskDisplay = errmaskDisplay;
      if (hideMB2Errors([returnVal]).length === 0) {
        returnVal.label = "";
        returnVal.errmaskDisplay = undefined;
        continue;
      }
      break;
    }
  }
  if (returnVal.label === "") {
    returnVal.label = "Unknown Error";
  }

  return returnVal;
}

export function getMB2ErrorInfoFromString(maybeErrorString: string): MimboxErrorInfo {
  let returnVal: MimboxErrorInfo = {
    label: maybeErrorString,
    description: "",
    errmaskDisplay: -1,
  };
  const parsedMaybeErrorString = maybeErrorString.toUpperCase().replace(/ /g, "_");
  const test = Object.entries(MB2Error);
  const foundErr = test.find(([key]) => key === parsedMaybeErrorString);
  if (foundErr?.length) {
    const errmaskDisplay = MB2_DISPLAY_ERRMASK[foundErr[1] as unknown as number];
    returnVal.errmaskDisplay = errmaskDisplay;
  }
  if (hideMB2Errors([returnVal]).length === 0) {
    return {
      label: maybeErrorString,
      description: "",
      errmaskDisplay: -1,
    };
  }

  return returnVal;
}

export function listMB2Errors(): MimboxErrorInfo[] {
  const errors: MimboxErrorInfo[] = [];
  Object.entries(MB2Error)
    .filter(([_, value]) => !isNaN(Number(value)))
    .forEach(([key, value]) => {
      let label = key.replace(/_/g, " ").toLowerCase();
      label = label.slice(0, 1).toUpperCase() + label.slice(1);
      const errmaskDisplay = MB2_DISPLAY_ERRMASK[value as MB2Error];
      let description = "";
      errors.push({ label: label, description: description, errmaskDisplay: errmaskDisplay });
    });
  return hideMB2Errors(errors);
}

export const TROUBLESHOOT_MB2_ERROR_MAP: Record<
  (typeof MB2_DISPLAY_ERRMASK)[number],
  {
    title: string; // title of error
    description: string; // short text with an overview
    // safetyWarnings: string[]; // If any warnings needs to be displayed to the user
    possibleCauses: string[];
    // troubleshooting: string;
    // relatedDocuments: string[]; // this should be a list of file paths in the storages, PDFs and Videos are OK
  }
> = {
  26: {
    title: "Filter clogged",
    description:
      "Triggered after too many “Cold water anti clogs” (which is a sequence that backflushes the filter with water from the storage tank) that the mimbox goes into if the flow from the filter has been too low for a period of time. How many “Cold water anti clogs” should trigger the error is a configurable parameter. The error can only happen in normal mode and will set the Mimbox into bypass mode.",
    possibleCauses: [
      "Dirty filter mesh (IF YES) → Inspect the filter tower & Perform a Monthly Maintenance where the filter is cleaned. {IMG_1}",
      "Faulty or clogged flow meter → Open left side panel and inspect/clean the flow sensor. {IMG_2}",
    ],
  },
  27: {
    title: "Pumping from WCU timeout",
    description:
      "The level in the filter keeps increasing without turning off the AC pump in the bottom module. And the filter tank risks overflowing.",
    possibleCauses: [
      "Clogged AC pump → Inspect and clean the AC pump & restart the box.",
      "Broken AC pump → Inspect and change the AC pump & restart the box.",
      "Valve 10 stuck open → Restart the box and see if water is flushing out from the filter into the micro plastic container for a long period of time during start up. If yes, change valve.",
      "Faulty or broken level sensor in the filter tower → Inspect/change the level sensor & restart the box. {IMG_1}",
    ],
  },
  28: {
    title: "WCU pump failure",
    description:
      "No level increase in the filter is detected even though the AC pump is on several times.",
    possibleCauses: [
      "Clogged AC pump → Inspect and clean the AC pump & restart the box.",
      "Broken AC pump → Inspect and change the AC pump & restart the box.",
      "Valve 10 stuck open → Restart the box and see if water is flushing out from the filter into the micro plastic container for a long period of time during start up. If yes, change valve.",
      "Faulty or broken level sensor in the filter tower → Inspect/change the level sensor & restart the box. {IMG_1}",
    ],
  },
  29: {
    title: "Filter tower leak detected",
    description:
      "The levelsensor which is a float switch inside the filter tower is triggered (Lifted).",
    possibleCauses: [
      "Leak in the filter tower → Inspect for water (IF YES) do a manual bypass.",
      "Something else has lifted the float switch → Inspect for other objects in the filter tower & restart",
      "Broken level sensor → inspect visually & restart",
      "Bad cable-connection to the filter tower → Disconnect and connect cable & restart {IMG_1}",
    ],
  },
  30: {
    title: "Emptying filter tank timeout",
    description:
      "Not able to empty the filter tank before start up = not reading a low enough level in a period of time",
    possibleCauses: [
      "Something is blocking the water flow in the sucktion line -> Inspect the sucktion line from the  filter tower, Perform a monthly maintenance {IMG_1}",
      "Something is blocking the water flow in the backflush line. (valve, dirt etc) Perform a monthly maintenance",
      "Air in the system -> Instepct connections in backflush and sucktion, restart.",
      "Pumps are damaged -> Listen to the pumps & start up",
      "Level sensor is broken -> Inspect level sensor in filter tower.",
    ],
  },
  31: {
    title: "Inaccurate pump flow",
    description:
      "The flowsensor on the backflush line reads in inaccurate flow during the start up sequence.",
    possibleCauses: [
      "Misreading in the data -> Try restarting the box",
      "Faulty or clogged flow meter → Open left side panel and inspect/clean the flow sensor.",
      "Faulty level sensor in the filter tank -> Inspect the sensor & restart",
    ],
  },
  32: {
    title: "Calibration timeout",
    description:
      "The Mimbox tries to calibrate but does not get any values that it can use during a period of time. The sensor values does not reach a steady state.",
    possibleCauses: [
      "Air in the system -> check connection for sucktion & backflush line & restart",
      "Broken Sensor card -> Try restarting and see if the problem persists",
      "Damaged/scratched glass in the sensor house -> Open the sensor house & inpect the glass and change if it is looking bad (Not clear after cleaning).",
    ],
  },
  33: {
    title: "Calibration Failed",
    description:
      "Readings from the quality sensor (RGB/TURB) that are rubbish, outside the acceptable range",
    possibleCauses: [
      "Air in the system -> check connection for sucktion & backflush line & restart",
      "Broken Sensor card -> Try restarting and see if the problem persists",
      "Damaged/scratched glass in the sensor house -> Open the sensor house & inpect the glass and change if it is looking bad (Not clear after cleaning).",
    ],
  },
  34: {
    title: "Discard low flow",
    description: "The backflush flow is too low during the discard test sequence in start up",
    possibleCauses: [
      "Dirty filter mesh (IF YES) -> Inspect the filter tower & Perform a Monthly Maintenance where the filter is cleaned.",
      "Faulty or clogged flow meter → Open left side panel and inspect/clean the flow sensor.",
      "Discard nozzles are broken/detached -> Inspect the nozzles and attach or swap if broken & restart the box. {IMG_1}",
    ],
  },
  35: {
    title: "Discard high flow",
    description: "The backflush flow is too High during the discard-test sequence in start up",
    possibleCauses: [
      "The discard nozzles clogged causing all/more water to go though backflush -> inspect discard nozzles  & clean if they are clogged & restart the box.",
      "Broken valve 7 or 1, unable to open -> Inspect valves by restarting and see if any water is sprays into the microplastic container during start up. If not, the valves needs to be replaced. <div class='flex gap-2 flex-wrap'>{IMG_1} {IMG_2}</div>",
    ],
  },
  36: {
    title: "Store high flow",
    description: "The backflush flow is too High during the Store-test sequence in start up",
    possibleCauses: [
      "Storing nozzle clogged -> inspect the nozzle inside the tank and clean if needed & restart the box.",
      "Valve 4 to storage tank broken -> Restart the box and chen for flow into the storage tank dueing startup. If no flow then valve needs to be changed. {IMG_1} ",
    ],
  },
  37: {
    title: "Store low flow error",
    description: "The backflush flow is too low during the Storing test sequence in start up",
    possibleCauses: [
      "Dirty filter mesh (IF YES) -> Inspect the filter tower & Perform a Monthly Maintenance where the filter is cleaned.",
      "Faulty or clogged flow meter → Open left side panel and inspect/clean the flow sensor.",
    ],
  },
  38: {
    title: "Pumping from WCU timeout (Startup)",
    description:
      "Water is pump from the WCU for too long whithout any level increase detected in the filter during start-up",
    possibleCauses: [
      "Broken AC pump → Inspect and change the AC pump & restart the box.",
      "Valve 10 stuck open → Restart the box and see if water is flushing out from the filter into the micro plastic container for a long period of time during start up. If yes, change valve.",
      "Faulty or broken level sensor in the filter tower  → Inspect and change",
    ],
  },
  39: {
    title: "No flow to washing machines",
    description:
      "The level sensor is indicating water in the storage tank, but there is no pressure increase when the pumps are running, indicating that there is no water flow.",
    possibleCauses: [
      "Broken or damaged pumps -> inspect for signs of damage by restarting and listening to the pumps sound. If there is no or very little, or a “bad” sound, the pumps are broken and needs to be changed.",
      "Broken level sensor -> inspect level sensor for water or corrosion in the cable. Change if bad and restart the box.",
      "Broken or faulty pressure sensor -> Restart the box, change sensor if problem remains. {IMG_1}",
    ],
  },
  40: {
    title: "Filling storage tank timeout",
    description: "The desired level in the storage tank is never reached.",
    possibleCauses: [
      "The tap is not open -> make sure the tap is open and connected to cold water in and restart the box. {IMG_1}",
      "Broken level sensor -> inspect level sensor for water or corrosion in the cable. Change if bad and restart the box.",
      "Ball valve 9 broken from the storage tank broken -> Inspect valve, restart box and see if water is going through the valve to the sewer. If so, replace the valve.",
      "Leaking tank -> inspect for water",
      "Valve 8 is broken -> Make sure tap is open, inspect if there is water flow into the storage tank during start up. If not, replace the valve. <div class='flex gap-2 flex-wrap'>{IMG_2} {IMG_3}</div>",
    ],
  },
  41: {
    title: "Washing machine inlet clogged",
    description:
      "The mimbox is trying to serve water, but the pressure increases above OK level too fast and the Mimbox ends up in a serving loop, starting and stopping the pumps without transporting water to the washing machine.",
    possibleCauses: [
      "Washing machine inlet valve broken -> This is a problem on the Washing machine, Check inlet filter, if it is not presant. The valve needs to be replaced.",
      "Inlet filter clogged (not removed upon installation) -> check to see if its present, if yes remove it.",
      "Flow restictor in the washing machine inlet -> check to see if it is present, consult with customer and possible remove it.",
    ],
  },
  42: {
    title: "No cold water flow in",
    description: "We dont read any flow in the cold water in.",
    possibleCauses: [
      "The tap is not open -> make sure the tap is open and connected to cold water in and restart the box.",
      "Broken or faulty flow meter",
      "Valve 8 is broken -> Make sure tap is open, inspect if there is water flow into the storage tank during start up. If not, replace the valve. {IMG_1}",
    ],
  },
  59: {
    title: "Washing machine pressure out timeout",
    description:
      "The washing machine pressure has been low for too long. No water seems to be served",
    possibleCauses: ["The connection to washing machine is loose", "Check valve is broken"],
  },
  60: {
    title: "Serving into filter tank",
    description:
      "The water level in the filter tank is rising when serving water. Checked after 5 minutes of serving.",
    possibleCauses: ["Backflush valve can't close properly"],
  },
  61: {
    title: "Too much water served",
    description: "We have been serving with a water flow for too long.",
    possibleCauses: [
      "Leak in conncetion to waching machine",
      "Error in washing machine",
      "Leak in Mimbox",
      "Backflush valve can't close properly",
    ],
  },
};
